import React from 'react'
import { getSocket } from '../lib'
import { NEW_NOTIFICATION } from '../lib/websockets/constants'
import { useAuthContext } from '../context/AuthProvider'
import { useAppContext } from '../context/AppProvider'
import { useHistory } from 'react-router-dom'
import { pathNameExists } from '../utils'
import addNotification from 'react-push-notification'

const allowedPaths = ['/auth/report-tasks', '/auth/my-activities', '/auth/settings']

const useNotificationSocketEvents = (callback?: () => Promise<void>) => {
  const { isAuthenticated } = useAuthContext()
  const { setIsLive, connected } = useAppContext()
  const [data, setData] = React.useState<any>(null)
  const socket = getSocket()
  const history = useHistory()
  const isOnLocation = pathNameExists(history.location.pathname, allowedPaths)
  const refetchData = async (data: any) => {
    setData(data)
    if (isOnLocation) {
      addNotification({
        title: 'Baotree',
        subtitle: data?.title || 'New Notification',
        message: data?.message || 'You have a new notification',
        theme: 'darkblue',
        native: true // Use native notifications
      })
    }
    await callback?.()
  }
  React.useEffect(() => {
    if (isAuthenticated && socket?.connected && connected && isOnLocation) {
      socket.on(NEW_NOTIFICATION, refetchData)
      setIsLive(socket?.connected)
    }
    // eslint-disable-next-line
  }, [isAuthenticated, socket?.connected, isOnLocation])

  return { data }
}

export default useNotificationSocketEvents
